import React from "react";
import {
  CircularProgress,
  Box,
  useTheme,
  CircularProgressProps,
} from "@mui/material";
import { globalStyles } from "../styles/GlobalStyles";

const Loader: React.FC<CircularProgressProps> = (props) => {
  const { palette } = useTheme();
  return (
    <Box sx={globalStyles.colCenter}>
      <CircularProgress
        size={32}
        sx={{ color: palette.custom.background.brand }}
        {...props}
      />
    </Box>
  );
};

export default Loader;
